import { ListResponseLogBean, LogControllerApi } from 'src/api/api'
import { BaseApi, configuration } from 'src/api/BaseApi'

class LogApi extends BaseApi {
    api: LogControllerApi

    constructor() {
        super()
        this.api = new LogControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(entity, id, size: number = 20, page: number = 1, sort = 'DESC'): Promise<ListResponseLogBean> {
        return this.call(() => this.api.logList(entity, id, { query: { size, page, sort: 'date,desc' } }))
    }
}

const logApi = new LogApi()
export default logApi


// WEBPACK FOOTER //
// ./src/component/app/log/LogApi.ts